import { TaskList } from "@/app/Tasks/Components/TaskList";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import {
  QueryTasksWhereColumn,
  SqlOperator,
  TaskStatus,
  TaskType,
} from "@/gql/graphql";

export function DashboardTaskList() {
  const { supplierId } = useGlobalSupplier();

  return (
    <TaskList
      id="dashboard-task-list"
      queryVariables={{
        status: [TaskStatus.Pending, TaskStatus.Overdue],
        supplierId: supplierId ?? undefined,
        where: {
          column: QueryTasksWhereColumn.Type,
          operator: SqlOperator.NotIn,
          value: [TaskType.ReviewDriverReceipts],
        },
      }}
    />
  );
}
